import { BaseGenerator } from '../core/BaseGenerator.js';

/**
 * US SSN generator following Single Responsibility Principle
 */
export class SsnGenerator extends BaseGenerator {
  generate(options = {}) {
    const { formatted = true } = options;

    // Area number (001-665, 667-899)
    let area;
    if (this.randomInt(0, 1)) {
      area = this.padZero(this.randomInt(1, 665), 3);
    } else {
      area = this.padZero(this.randomInt(667, 899), 3);
    }

    // Group number (01-99)
    const group = this.padZero(this.randomInt(1, 99), 2);

    // Serial number (0001-9999)
    const serial = this.padZero(this.randomInt(1, 9999), 4);

    const ssn = area + group + serial;
    return formatted ? `${area}-${group}-${serial}` : ssn;
  }
}